import React, { useEffect, useState } from 'react';
import { Handshake, Mail, Plus } from 'lucide-react';
import { partnerSections as partnerSectionsMock } from '../data/mock';
import { api } from '../api/client';
import SocialShare from '../components/SocialShare';

export default function Partners() {
  const [sections, setSections] = useState(partnerSectionsMock);

  useEffect(() => {
    let alive = true;
    api.getPartners().then((rows) => {
      if (alive && Array.isArray(rows) && rows.length > 0) setSections(rows);
    }).catch(() => { /* fallback su mock */ });
    return () => { alive = false; };
  }, []);

  return (
    <div className="bg-navy min-h-screen">
      <section className="relative py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-navy-dark to-navy"></div>
        <div className="relative max-w-5xl mx-auto px-4 lg:px-8 text-center">
          <Handshake size={48} className="text-pink-brand mx-auto mb-4" />
          <h1 className="font-brand text-5xl md:text-6xl font-bold text-white mb-4">Partners</h1>
          <div className="w-24 h-1 bg-pink-brand mx-auto rounded"></div>
          <p className="text-white/70 mt-6 max-w-2xl mx-auto">
            Aziende e realtà che sostengono il Memorial Eugenio Abbro. Un grazie sincero per rendere possibile questo evento.
          </p>
          <div className="mt-6 flex justify-center">
            <SocialShare title="Partners · Memorial Eugenio Abbro" />
          </div>
        </div>
      </section>

      {sections.map((section) => (
        <PartnerSectionBlock key={section.id} section={section} />
      ))}

      <section className="pb-20 pt-6">
        <div className="max-w-4xl mx-auto px-4 lg:px-8">
          <div className="glass-card p-8 text-center">
            <Plus size={36} className="text-pink-brand mx-auto mb-4" />
            <h3 className="font-display text-2xl font-bold text-white uppercase mb-3">Diventa Partner</h3>
            <p className="text-white/75 mb-6 max-w-xl mx-auto">
              Vuoi sostenere il Memorial Eugenio Abbro e associare il tuo marchio a un evento di sport giovanile che coinvolge oltre 300 ragazzi? Contattaci per scoprire i pacchetti partnership.
            </p>
            <a href="mailto:memorialeugenioabbro@gmail.com" className="btn-primary">
              <Mail size={18} /> Scrivici una mail
            </a>
            <div className="mt-6">
              <SocialShare title="Diventa partner del XIV Memorial Eugenio Abbro" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function PartnerSectionBlock({ section }) {
  const items = section.items || [];
  return (
    <section className="pb-10">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        <div className="mb-6">
          <h2 className="section-title text-2xl">{section.titolo}</h2>
          {section.sottotitolo && <p className="text-white/60 text-sm mt-3">{section.sottotitolo}</p>}
        </div>

        {section.modalita === 'image' && section.immagine ? (
          <div className="bg-white rounded-2xl p-6 lg:p-8">
            <img src={section.immagine} alt={section.titolo} className="w-full h-auto max-h-[520px] object-contain mx-auto" />
          </div>
        ) : items.length === 0 ? (
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 text-center text-white/50 text-sm">
            Nessun partner aggiunto a questa sezione.
          </div>
        ) : (
          <div className="bg-white rounded-2xl p-5 lg:p-7">
            <div className={`grid gap-4 items-center ${section.id === 'main' ? 'grid-cols-1 sm:grid-cols-3' : 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5'}`}>
              {items.map((s) => <LogoCard key={s.id} sponsor={s} large={section.id === 'main'} />)}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

function LogoCard({ sponsor, large = false }) {
  if (sponsor.logo) {
    return (
      <div className="flex flex-col items-center justify-center text-center p-3">
        <img src={sponsor.logo} alt={sponsor.name} className={`${large ? 'h-20' : 'h-14'} w-auto object-contain mb-2`} />
        <div className="text-navy-dark font-bold text-xs leading-tight">{sponsor.name}</div>
        <div className="text-gray-500 text-[10px] mt-0.5">{sponsor.tagline}</div>
      </div>
    );
  }
  return (
    <div className="group flex flex-col items-center justify-center text-center p-3 rounded-xl hover:bg-gray-50 transition-colors min-h-[110px]">
      <div className={`${large ? 'w-20 h-20 text-xl rounded-2xl' : 'w-12 h-12 text-sm rounded-full'} flex items-center justify-center text-white font-bold mb-2 group-hover:scale-110 transition-transform shadow-md`} style={{ backgroundColor: sponsor.color }}>
        {sponsor.name.substring(0, 2).toUpperCase()}
      </div>
      <div className="text-navy-dark font-bold text-xs leading-tight">{sponsor.name}</div>
      <div className="text-gray-500 text-[10px] mt-0.5">{sponsor.tagline}</div>
    </div>
  );
}
